import { DocumentRequestBtn } from '@components/buzzkuri/shared/DocumentRequestBtn'
import { Markdown } from '@components/shared/Markdown'
import { Slugs } from '@type/buzzkuri/programs-categor'
import { getDomain } from '@utils/http'
import React from 'react'

type Props = {
  features: string
  slugs: Slugs
}

export const CategoryFeaturesContent = ({
  features,
  slugs,
}: Props): JSX.Element => (
  <div className="flex flex-col px-[6.1vw] pt-[10.1vw] lg:pt-[2.9vw] lg:pr-[3.6vw] pb-[8.8vw] lg:pb-[3.4vw] lg:pl-[1.8vw] bg-[#F7F6F5]">
    <div className="text-[3.7vw] lg:text-[1.3vw] leading-[7.5vw] lg:leading-[2.5vw]">
      <Markdown content={features} />
    </div>
    <div className="flex justify-center items-center">
      <div className="mt-[8.3vw] lg:mt-[2.7vw] w-[50.1vw] lg:w-[25.9vw] h-[10.1vw] lg:h-[4.8vw] rounded-[11px] lg:rounded-[20px]">
        <DocumentRequestBtn
          title="資料ダウンロード"
          customDataAttribute={{
            attributeName: 'data-program-feature-button',
            attributeValue: `https://${getDomain}/programs/${slugs[0]}`,
          }}
          classes="rounded-[20px] shadow-button text-[3.5vw] lg:text-[1.4vw]"
          hasArrow
        />
      </div>
    </div>
  </div>
)
